import { styled } from "../../stitches.config";
import { FlexBox } from "../primitives";

export const Section = styled(FlexBox, {
  alignItems: "center",
  gap: 20,
  marginTop: 40,
  justifyContent: "center",
});

export const Group = styled(FlexBox, {
  alignItems: "center",
  flexDirection: "column",
  gap: 10,
});

export const LabelGroup = styled(FlexBox, {
  alignItems: "center",
  gap: 5,
});
